import { SecondaryButton } from "@graffer-inc/console-design-kit";
import React from "react";

type Props = {
  query?: string;
  onSearch: (query: string) => void;
  onClear: () => void;
};

export const SearchMenu: React.FC<Props> = ({ query, onSearch, onClear }) => {
  const [input, setInput] = React.useState<string>(query ?? "");
  return (
    <div className="column">
      <div className="field has-addons">
        <p className="control has-icons-left has-icons-right">
          <input
            className="input"
            placeholder="手続き名で検索"
            value={input}
            onChange={(e) => setInput(e.target.value)}
            style={{
              fontSize: "14px",
            }}
          />
          <span className="icon is-small is-left">
            <i className="fas fa-search" />
          </span>
          <span
            className="icon is-small is-right"
            role="button"
            onClick={() => {
              setInput("");
              onClear();
            }}
            style={{ pointerEvents: "initial", cursor: "pointer" }}
          >
            <i className="fas fa-times" />
          </span>
        </p>
        <p className="control">
          <SecondaryButton
            onClick={() => {
              onSearch(input);
            }}
            text="検索"
          />
        </p>
      </div>
    </div>
  );
};
